import * as ReactHelmetAsync from 'react-helmet-async';
const Helmet = ReactHelmetAsync.Helmet || (ReactHelmetAsync as any).default?.Helmet;
import { Award, RotateCcw, RefreshCw, ClipboardCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/layout/Navigation';
import { Footer } from '@/components/layout/Footer';
import { PageHero } from '@/components/sections/PageHero';

const trainingPrograms = [
  {
    icon: Award,
    title: 'Tailwheel Endorsement',
    path: '/training/tailwheel-endorsement',
    summary: 'Earn your tailwheel endorsement in 5-10 hours of dual instruction.',
  },
  {
    icon: RotateCcw,
    title: 'CFI Spin Training',
    path: '/training/cfi-spin-training',
    summary: 'Satisfy the FAR 61.183 spin training requirement for your CFI checkride.',
  },
  {
    icon: RefreshCw,
    title: 'Tailwheel Refresh',
    path: '/training/tailwheel-refresh',
    summary: 'Build proficiency before your next opportunity to fly a tailwheel aircraft.',
  },
  {
    icon: ClipboardCheck,
    title: 'Flight Review',
    path: '/training/flight-review',
    summary: 'Complete your flight review in a tailwheel — more fun than the same old 172.',
  },
];

export function Training() {
  return (
    <>
      <Helmet>
        <title>Flight Training Programs | Total Tailwheel</title>
        <meta
          name="description"
          content="Tailwheel endorsement, CFI spin training, tailwheel refresher, and flight reviews in our 1954 Cessna 170B at Minute Man Air Field near Boston."
        />
        <meta
          name="keywords"
          content="tailwheel endorsement, CFI spin training, tailwheel refresh, flight review, tailwheel training Massachusetts"
        />
        <link rel="canonical" href="https://totaltailwheel.com/training" />
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        <Navigation />
        <PageHero title="Training" />

        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="grid sm:grid-cols-2 gap-6">
                {trainingPrograms.map((program) => {
                  const Icon = program.icon;
                  return (
                    <Link
                      key={program.path}
                      to={program.path}
                      className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow group"
                    >
                      <div className="flex items-start gap-3 mb-3">
                        <div className="bg-primary/10 p-2 rounded-lg shrink-0">
                          <Icon className="text-primary" size={24} />
                        </div>
                        <h2 className="text-xl font-medium text-primary group-hover:text-primary/80 transition-colors">
                          {program.title}
                        </h2>
                      </div>
                      <p className="text-foreground/70 text-sm">{program.summary}</p>
                    </Link>
                  );
                })}
              </div>

              <div className="mt-12 text-center">
                <Link
                  to="/inquire"
                  className="inline-block bg-primary text-white px-8 py-3 rounded-lg hover:bg-primary/90 transition-colors font-medium"
                >
                  Inquire Now
                </Link>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}
